<template>
  <VincCalculating />
</template>

<script>
import VincCalculating from "@/components/Calculatings/VincCalculating";
export default {
  components: {
    VincCalculating,
  },
};
</script>

<style></style>
